import { ref } from 'vue';

const cursor = ref('');
const cursorCounts = ref<Record<string, number>>({ pointer: 0, grab: 0 });

const updateCursor = () => {
    // Priority: 'grab' > 'pointer'
    if (cursorCounts.value.grab > 0) {
        cursor.value = 'grab';
    } else if (cursorCounts.value.pointer > 0) {
        cursor.value = 'pointer';
    } else {
        cursor.value = '';
    }
};

const addCursor = (cursorType: string) => {
    if (cursorType && (cursorType === 'pointer' || cursorType === 'grab')) {
        cursorCounts.value[cursorType] = (cursorCounts.value[cursorType] || 0) + 1;
        updateCursor();
    }
};

const removeCursor = (cursorType: string) => {
    if (cursorType && (cursorType === 'pointer' || cursorType === 'grab')) {
        cursorCounts.value[cursorType] = Math.max(0, (cursorCounts.value[cursorType] || 0) - 1);
        updateCursor();
    }
};

const setCursor = (val: string) => {
    // Legacy method for backwards compatibility
    if (val) {
        addCursor(val);
    } else {
        cursorCounts.value.pointer = 0;
        cursorCounts.value.grab = 0;
        cursor.value = '';
    }
};

export const useCursor = () => {
    return {
        cursor,
        addCursor,
        removeCursor,
        setCursor,
    };
};
